import fetchJSON from '@api/api_helper';
import { notifyOverLimits } from '@helpers/notify_over_limits';

const getUrl = (assetKey) => `/api/v4/assets/${assetKey}`;

export default (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.assetKey), options, updateFetchControllers)
);

// helper: returns custom fields as an object
export const formatCustomFields = (response) => {
  if (!response.included) { return undefined; }

  const formattedCustomFields = {};

  response.included.forEach((field) => {
    formattedCustomFields[field.attributes.key] = field.attributes.value;
  });

  return formattedCustomFields;
};


export const updateAsset = ({ assetKey, attributes, params }, updateFetchControllers) => {
  const appendedOptions = {
    method: 'PUT',
    body: {
      data: {
        attributes
      }
    },
    params,
  };

  return fetchJSON(getUrl(assetKey), appendedOptions, updateFetchControllers);
};

export const deleteAsset = (assetKey, updateFetchControllers) => {
  const url = getUrl(assetKey);
  const appendedOptions = {
    method: 'DELETE'
  };

  return fetchJSON(url, appendedOptions, updateFetchControllers);
};

export const createAssets = async (options, updateFetchControllers) => {
  const url = options.url;
  const appendedOptions = {
    method: 'POST',
    body: {
      section_key: options.section_key,
      data: options.data
    },
    context: options.context
  };

  const response = await fetchJSON(url, appendedOptions, updateFetchControllers);
  if (response?.meta?.over_limits) {
    notifyOverLimits();
  }
  return response;
};
